export const baseUrl = "https://api.nedachef-academy.com";
